import Icon from '../components/Icon.vue'

Icon.register({
  carrot: {
    width: 512,
    height: 512,
    paths: [
      {
        d: 'M298.2 156.6C245.5 130.9 183.7 146.1 148 189.4L203.2 244.6C209.5 250.9 209.5 261 203.2 267.2 200.1 270.3 196 271.9 191.9 271.9S183.7 270.3 180.6 267.2L130.4 217 2.3 479.7C-0.6 485.7-0.8 493 2.3 499.4 7.7 510.5 21.2 515.1 32.3 509.7L165.9 444.5 116.7 395.3C110.4 389.1 110.4 378.9 116.7 372.7 123 366.5 133.1 366.5 139.3 372.7L196.3 429.7 298.3 379.9C322.3 368.2 342.8 348.6 355.4 322.8 385.5 261.1 359.9 186.7 298.2 156.6zM390.3 121.7C409.8 81 399.7 32.9 360 0 309.7 41.7 307.5 107.5 352.1 151.9L360.1 159.9C404.5 204.5 470.4 202.3 512 152 479.1 112.3 431 102.2 390.3 121.7z'
      }
    ]
  }
})
